<template>
  <div class="video-speeder">
    <div
      v-if="inputInfo.filename"
      class="areas"
    >
      <div class="view-area">
        <video
          ref="viewVideo"
          :src="$.handleAssetsUrl(inputInfo.filename)"
          :volume="vol"
        ></video>
      </div>
      <div class="controls-area">
        <controls
          ref="controls"
          :vol="vol"
          :playback-rate="playbackRate"
          @updateVol="updateVol"
          @updateTiming="updateTiming"
          @togglePlay="togglePlay"
        ></controls>
      </div>
    </div>
    <div
      v-else
      class="blank-page"
    >
      <div
        v-if="uploading.forceVisible"
        class="progress-wrapper"
      >
        <uploading-progress
          :bar="uploading.progress"
          @cancel="cancelUploadTask"
        ></uploading-progress>
      </div>
      <blank-add
        v-else
        class="blank-add"
        @changeFiles="changeFile"
      ></blank-add>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlankAdd from '@/components/global/blankAdd.vue';
import { uploadChunk, mergeBlock } from '@/components/commonFunc/webApi';
import UploadingProgress from '@/components/videoSpeeder/uploadingProgress';
import Controls from '@/components/videoSpeeder/controls';
export default {
  components: {
    BlankAdd,
    UploadingProgress,
    Controls
  },
  data() {
    return {
      vol: 1,
      cancelToken: { value: false },
      uploading: {
        progress: 0,
        forceVisible: false
      },
      isPaused: true,
      playbackRate: 1
    };
  },
  computed: {
    ...mapGetters({
      inputInfo: 'videoSpeeder/getInputInfo'
    })
  },
  watch: {
    inputInfo(val) {
      val = val.filename;
      if (val) {
        this.$nextTick(() => {
          this.listenCurrentTime();
          this.listenEnded();
          this.playbackRate = this.getPlaybackRate();
        });
        this.$store.commit('common/setEditing', true);
        if (this.piping) {
          this.piping = false;
          this.$sensors.track('toolVideoUpload', {
            tool_type: '变速宝',
            video_source: '其他工具',
            video_duration: this.inputInfo.duration || 0,
            video_size: this.inputInfo.size / 1024 / 1024 || 0
          });
        } else {
          let video_source = '';
          if (this.inputInfo.fileType == 26) {
            video_source = '视频库';
          } else if (this.inputInfo.fileType == 27) {
            video_source = '作品库';
          } else {
            video_source = '本地上传';
          }
          this.$sensors.track('toolVideoUpload', {
            tool_type: '变速宝',
            video_source,
            video_duration: this.inputInfo.duration || 0,
            video_size: this.inputInfo.size / 1024 / 1024 || 0
          });
        }
      }
    }
  },
  created() {
    this.$bus.on('changeFiles', this.changeFile);
  },
  mounted() {
    if (this.$route.query.pipe === '1') {
      let data = (this.$store.getters['completed/getPipeFiles'] || [])[0];
      if (data) {
        this.piping = true;
        this.$store.commit('videoSpeeder/setInputInfo', {
          ...data,
          filename: data.url
        });
        this.$store.commit('uploader/setVideoUrl', data.url);
        console.log('turbo: mounted -> data.url', data.url);
      }
    }
    let shot = this.$store.getters['uploader/videoUrlShot'];
    if (shot.url && !(this.$route.query || {}).id && !(this.$route.query || {}).pipe) {
      this.changeFile(shot);
    }
  },
  beforeDestroy() {
    this.$bus.off('changeFiles', this.changeFile);
    this.$store.commit('videoSpeeder/setInputInfo', {});
    this.$store.commit('videoSpeeder/clearFiles');
    if (this.$refs.viewVideo) {
      this.$refs.viewVideo.removeEventListener('timeupdate', this.onTimeupdate);
      this.$refs.viewVideo.removeEventListener('ended', this.onEnded);
    }
  },
  methods: {
    async changeFile(data = {}) {
      let { blob: file, url = '' } = data;
      if (url && !file) {
        this.$store.commit('videoSpeeder/setInputInfo', {
          filename: this.$.unhandleAssetsUrl(url),
          ...data,
          cover: ''
        });
        return;
      }
      if (await this.checkVideoFormat(file)) {
        this.cancelToken.value = false;
        this.uploading.progress = 0;
        this.uploading.forceVisible = true;
        this.uploadBigFile({
          file,
          cancelToken: this.cancelToken,
          progressCallback: (p) => {
            this.uploading.progress = p;
          }
        });
      }
    },
    async checkVideoFormat(file) {
      if (file.type !== 'video/mp4') {
        this.$message({
          message: '只支持MP4格式的文件',
          type: 'error',
          center: true
        });
        return false;
      } else if (file.size > 200 * 1024 * 1024) {
        this.$message({
          message: `文件"${file.name}"大小超过限制`,
          type: 'error',
          center: true
        });
        return false;
      } else if ((await this.$.getDuration(file)) > 3600) {
        this.$message({
          message: `文件"${file.name}"时长超过限制`,
          type: 'error',
          center: true
        });
        return false;
      }
      return true;
    },
    async uploadBigFile(body) {
      let file = body.file;
      let filesize = file.size; //文件整体大小
      let perSize = 6 * 1024 * 1024; //每片大小
      let chunkNumbers = Math.ceil(filesize / perSize); // 总片数，向上取整
      let start = 0; //分片开头
      let end = 0; //分片结尾
      let filename = file.name;
      let uploadCompletedNumbers = 0;
      let returnValue = { type: 'Fail', data: null };

      if (body.progressCallback) {
        //假进度
        body.progressCallback(Math.round((0.2 / chunkNumbers) * 100));
      }

      for (let i = 0; i < chunkNumbers; i++) {
        if (body.cancelToken.value) {
          returnValue.type = 'Cancel'; //取消上传
          return returnValue;
        }
        start = end;
        end = start + perSize;
        if (end > filesize) {
          end = filesize;
        }
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('files[]', chunk, filename);
        let result = await uploadChunk({
          formData: formData,
          index: i,
          perSize: perSize,
          filesize: filesize,
          chunkNumbers: chunkNumbers
        });
        if (result) {
          uploadCompletedNumbers++;
          if (body.progressCallback) {
            body.progressCallback(Math.round((uploadCompletedNumbers / chunkNumbers) * 100));
            // body.progressCallback((uploadCompletedNumbers / chunkNumbers).toFixed(2) * 100);
          }
        } else {
          break; //一个分片上传失败，就判断为整体失败
        }
      }
      if (body.cancelToken.value) {
        this.uploading.forceVisible = false;
        returnValue.type = 'Cancel'; //取消上传
        return returnValue;
      }
      if (uploadCompletedNumbers == chunkNumbers) {
        let result = await mergeBlock({ filename: filename, chunkNumber: chunkNumbers });
        if (result) {
          if (body.cancelToken.value) {
            this.uploading.forceVisible = false;
            returnValue.type = 'Cancel'; //取消上传
            return returnValue;
          }
          returnValue.type = 'Success';
          returnValue.data = result.filename;
          this.uploading.forceVisible = false;
          result.filename &&
            this.$store.commit('videoSpeeder/setInputInfo', {
              filename: result.filename,
              name: file.name,
              size: file.size,
              duration: file.duration
            });
          this.$store.commit('uploader/setVideoUrl', result.filename);
          return returnValue;
        }
      }
      returnValue.type = 'Fail';
      this.uploading.forceVisible = false;
      return returnValue;
    },
    cancelUploadTask() {
      this.cancelToken.value = true;
      this.uploading.progress = 0;
      this.uploading.forceVisible = false;
    },
    listenCurrentTime() {
      let videoEl = this.$refs.viewVideo;
      videoEl.addEventListener('timeupdate', this.onTimeupdate);
    },
    onTimeupdate() {
      let videoEl = this.$refs.viewVideo;
      this.$refs.controls.updateTiming(videoEl.currentTime);
    },
    listenEnded() {
      let videoEl = this.$refs.viewVideo;
      videoEl.addEventListener('ended', this.onEnded);
    },
    onEnded() {
      this.isPaused = true;
    },
    updateTiming(val) {
      let videoEl = this.$refs.viewVideo;
      if (videoEl && videoEl.paused) {
        videoEl.currentTime = val;
      }
    },
    togglePlay() {
      let videoEl = this.$refs.viewVideo;
      if (videoEl && videoEl.paused) {
        if (videoEl.duration - videoEl.currentTime < 0.1) {
          videoEl.currentTime = 0;
        }
        videoEl.play();
        this.isPaused = false;
      } else if (videoEl && !videoEl.paused) {
        videoEl.pause();
        this.isPaused = true;
      }
    },
    updateVol(val) {
      this.vol = val;
      let videoEl = this.$refs.viewVideo;
      if (videoEl) {
        videoEl.volume = val;
      }
    },
    getPlaybackRate() {
      let rate = 1;
      let video = this.$refs.viewVideo;
      if (video) {
        rate = video.playbackRate;
      }
      return rate;
    },
    updatePlaybackRate(rate = 1) {
      let video = this.$refs.viewVideo;
      if (video) {
        video.playbackRate = rate;
        this.playbackRate = rate;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.video-speeder {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f6f7fb;
}
.blank-page {
  position: absolute;
  background-color: #f6f7fb;
  width: 100%;
  height: 100%;
  padding: 17px 65px 54px 74px;
}
.progress-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.areas {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 17px 65px 0 74px;
}
.view-area {
  min-width: 618px;
  position: relative;
  height: 100%;
  background-color: #fff;
  & > video {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
.controls-area {
  height: 276px;
  flex-shrink: 0;
}
</style>
